import { render, staticRenderFns } from "./filter-item.vue?vue&type=template&id=bf15bbdc&scoped=true&"
import script from "./filter-item.vue?vue&type=script&lang=js&"
export * from "./filter-item.vue?vue&type=script&lang=js&"
import style0 from "./filter-item.vue?vue&type=style&index=0&id=bf15bbdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf15bbdc",
  null
  
)

export default component.exports